import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from "../lib/core";
import { useTheme } from '@mui/material/styles';
import { Box, Card, CardMedia, CardContent, Typography, Avatar, AvatarGroup, Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import "./ProductCard.css";

export default function LandingProductCard(props) {
  const theme = useTheme();
  const { firestoreInstance } = useContext(AuthContext);

  const [openImage, setOpenImage] = useState(false);
  const [imageSrc, setImageSrc] = useState('');

  const service = props.service || {};

  const handleClick = (e) => {
    if (props.showDetails) props.showDetails(service);
  };

  return (
    <>
    <Card className="product-card" elevation={0} sx={{ boxShadow: 'none', width: '100%' }} onClick={handleClick}>
      <Box className="product-hero" sx={{ minHeight: 74, display: 'flex', alignItems: 'center', p: 1 }}>
        <Box className="product-title-overlay" sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <div className="product-title-thumb" onClick={(e) => {
              e.stopPropagation();
              const src = service.image || '';
              setImageSrc(src);
              if (src) setOpenImage(true);
            }}>
              <img src={service.image || ''} alt={service.name} />
            </div>
            <Box>
              <Typography className="product-title" variant="h6" sx={{ fontSize: { xs: '0.8rem', md: '1rem' } }}>{service.name}</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Rating name="read-only" value={typeof service.rating !== 'undefined' ? service.rating : 4.2} size="small" readOnly precision={0.1} sx={{ color: '#042027' }} />
              </Box>
            </Box>
          </Box>
          <Box sx={{ mr: 2 }}>
            <span className="price-badge">{typeof service.price !== 'undefined' ? `$${service.price}` : ''}</span>
          </Box>
        </Box>
      </Box>
      <CardContent sx={{pb: 0}}>
        <Box className="product-meta">
          <Typography variant="body2" component="div" align="left" color="text.secondary" className="product-description" sx={{ mt: 1 }}>
            { service.description ? <div dangerouslySetInnerHTML={{ __html: service.description }} /> : '' }
          </Typography>
        </Box>
      </CardContent>
    </Card>
      <Dialog open={openImage} onClose={() => setOpenImage(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ m: 0, p: 1 }}>
          {service.name}
          <IconButton
            aria-label="close"
            onClick={() => setOpenImage(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0, display: 'flex', justifyContent: 'center' }}>
          <img src={imageSrc} alt={service.name} style={{ width: '100%', height: 'auto', objectFit: 'contain' }} />
        </DialogContent>
      </Dialog>
    </>
  );
}
